import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft, Home } from "lucide-react";
import Header from "../components/Header";
import TrustStrip from "../components/TrustStrip";
import { categories as mockCategories, categoriesTrust } from "../mock";
import { fetchCategories } from "../api";

const CategoryCard = ({ c }) => (
  <div
    style={{ backgroundColor: c.bg }}
    className="rounded-2xl p-4 sm:p-5 flex flex-col hover:shadow-xl hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
  >
    <div className="h-32 sm:h-36 rounded-xl overflow-hidden mb-3 bg-white/50">
      <img
        src={c.img}
        alt={c.name}
        loading="lazy"
        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
      />
    </div>
    <div className="text-[16px] sm:text-[17px] font-bold leading-tight" style={{ color: c.color }}>
      {c.name}
    </div>
    <div className="text-[10.5px] sm:text-[11.5px] text-gray-600 mt-1">{c.sub}</div>
    <Link
      to={`/category/${c.slug}`}
      style={{ backgroundColor: c.arrow }}
      className="mt-3.5 w-9 h-9 rounded-full flex items-center justify-center text-white shadow-md hover:scale-110 hover:shadow-lg transition-transform duration-200"
      aria-label={`Shop ${c.name}`}
    >
      <ArrowRight size={17} />
    </Link>
  </div>
);

const Categories = () => {
  const [categories, setCategories] = useState(mockCategories);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories()
      .then((d) => d?.length && setCategories(d))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header variant="simple" />

      <div className="bg-[#0f9d4b] py-3.5">
        <div className="max-w-[1400px] mx-auto px-4 relative flex items-center justify-center gap-6">
          <div className="absolute left-4 flex items-center gap-2">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-1.5 bg-white/15 hover:bg-white/25 text-white text-[12px] font-semibold rounded-full px-3.5 py-1.5 transition-colors"
              aria-label="Go back"
            >
              <ArrowLeft size={14} /> Back
            </button>
            <Link
              to="/"
              className="flex items-center gap-1.5 bg-white text-[#0e7a3d] hover:bg-green-50 text-[12px] font-bold rounded-full px-3.5 py-1.5 transition-colors"
              aria-label="Go to home"
            >
              <Home size={14} /> Home
            </Link>
          </div>
          <div className="hidden sm:block h-[2px] bg-white/40 flex-1 max-w-[230px] rounded" />
          <h1 className="text-white text-[22px] sm:text-[26px] font-bold whitespace-nowrap">
            Shop by Category
          </h1>
          <div className="hidden sm:block h-[2px] bg-white/40 flex-1 max-w-[230px] rounded" />
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-3 lg:px-4 pt-6 pb-4">
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 lg:gap-5">
          {categories.map((c) => (
            <CategoryCard key={c.slug} c={c} />
          ))}
        </div>
      </div>

      <TrustStrip items={categoriesTrust} cols={5} />
    </div>
  );
};

export default Categories;
